import { render, staticRenderFns } from "./RcTermsDetail.vue?vue&type=template&id=550ca430&scoped=true"
import script from "./RcTermsDetail.vue?vue&type=script&lang=js"
export * from "./RcTermsDetail.vue?vue&type=script&lang=js"
import style0 from "./RcTermsDetail.vue?vue&type=style&index=0&id=550ca430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ca430",
  null
  
)

export default component.exports